module.exports = __webpack_public_path__ + "img/logoSB.eff4d34b.png";